import React, { useEffect, useState } from 'react';
import { Loader2, ReceiptText, TrendingDown, TrendingUp } from 'lucide-react';
import client from '../../lib/api';
import { accountHook } from '../../lib/domHooks';

const money = (value) => `${Math.abs(Number(value || 0)).toLocaleString('tr-TR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
})} ₺`;

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('tr-TR');
};

// Panelden elle yapılan bakiye ekleme/düşmeleri "Sistem Düzenlemesi" olarak
// listeler. Bu hareketler bilinçli olarak Çekimlerim/Yatırımlarım'da
// görünmez: orada "Ödendi" rozetiyle duran bir kesinti oyuncuya kendisine
// ödeme yapılmış gibi görünüyordu. Sanal tür sunucudadır
// (finance_router.ADJUSTMENT_TYPE); açıklamayı canlı destek yapar.
const AccountActivity = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/finance/transactions', { params: { limit: 100, type: 'adjustment' } })
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="pusu-panel p-10 text-center text-gray-400" {...accountHook('loading')}>
        <Loader2 className="inline animate-spin mr-2 text-[var(--pusu-gold)]" /> Yükleniyor...
      </div>
    );
  }

  return (
    <div className="pusu-panel p-6" {...accountHook('panel')}>
      <div className="flex items-center gap-3 mb-2" {...accountHook('page-header')}>
        <ReceiptText size={20} className="text-[var(--pusu-gold)]" />
        <h2 className="text-xl font-bold gold-text" {...accountHook('title')}>Hesap Hareketleri</h2>
      </div>
      <p className="text-sm text-gray-400 mb-5" {...accountHook('subtitle')}>
        Hesabınızda sistem tarafından yapılan bakiye düzenlemeleri. Bir hareketle
        ilgili bilgi almak için canlı destekle iletişime geçebilirsiniz.
      </p>

      {items.length === 0 ? (
        <div className="pusu-card p-8 text-center text-gray-500" {...accountHook('empty')}>
          Hesabınızda herhangi bir düzenleme bulunmuyor.
        </div>
      ) : (
        <div className="space-y-2" {...accountHook('list')}>
          {items.map((item) => {
            const positive = Number(item.amount || 0) >= 0;
            return (
              <div
                key={item.id}
                className="pusu-card p-3 flex items-center gap-3"
                data-bhs-status={positive ? 'credit' : 'debit'}
                {...accountHook('row')}
              >
                <div className={`${positive ? 'account-result-win' : 'account-result-loss'} w-10 h-10 rounded-lg flex items-center justify-center shrink-0`}>
                  {positive
                    ? <TrendingUp size={16} className="text-green-400" />
                    : <TrendingDown size={16} className="text-red-400" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate">
                    {item.method || 'Sistem Düzenlemesi'}
                  </div>
                  <div className="text-xs text-gray-400 truncate">
                    {formatDate(item.created_at)}
                  </div>
                </div>
                <div
                  className={`text-sm font-bold ${positive ? 'text-green-400' : 'text-red-400'}`}
                >
                  {positive ? '+' : '−'}{money(item.amount)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AccountActivity;
